import { DateTime } from 'luxon';
export const calculateVanAgeInYears = (vanAge) => DateTime.now().year - vanAge;
export const calculateRemainingEligibiltyYears = (vanYear, maximumAge) => {
    const vanAge = calculateVanAgeInYears(vanYear);
    return maximumAge - vanAge;
};
